export default {
    current_choice: 'Текущ избор',
    book_now: 'Резервирай сега',
    minimum_age: 'Само за лица над {age} години',
    excess_liability: 'Самоучастие',
    security_deposit: 'Депозит за сигурност',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Същото за същото',
    full_to_full: 'Пълен до пълен',
    miles_per_rental: '{mileage} безплатни мили на наем',
    km_per_rental: '{mileage} безплатни км на наем',
    unlimited_mileage: 'Неограничен пробег',
    unlimited_mileage_km: 'Неограничени км',
    non_amendable: 'Не може да се променя',
    non_refundable: 'Без възстановяване',
    free_cancellation_until: 'Безплатно анулиране до',
    basic_free_cancellation: 'Безплатно анулиране до 48 часа преди началния час',
    cancellation_in_line_with: 'Анулиране според',
    tcs: 'Общи условия',
    free_extras_on_collection: 'Два безплатни екстри при получаване',
    glass_and_tyres_covered: 'Покрити стъкла и гуми',
    number_of_passengers: 'Брой пътници',
    number_of_bags: 'Брой чанти',
    fuel_type: 'Вид гориво',
    co2: 'CO2',
    aircon: 'Климатик',
    transmission: 'Скоростна кутия',
    book_type: 'Резервирай {type}',
    debit_card_deposit: 'Дебитна карта приета за депозит',
    fast_track_included: 'Бързо обслужване включено',
    view_all: 'Вижте всичко',
};
